import React, { useEffect, useState } from "react";
import TopChart from "./Cards/TopChart";
import TicketsByMonth from "./Cards/TicketsByMonth";
import TicketsToStaff from "./Cards/TicketsToStaff";
import TicketsByStatuses from "./Cards/TicketsByStatuses";
import { EndPoints } from "../../../utils/apiEndpoints";
import { useLocation, useNavigate } from "react-router-dom";

const Dashboard = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [year, setYear] = useState<number>(new Date().getFullYear());

    useEffect(() => {
        const timer = setTimeout(() => {
            if (location.pathname === EndPoints.RESETPASSWORD) {
                navigate(EndPoints.ANALYTICS, { replace: true });
            }
        }, 100);
        return () => clearTimeout(timer);
    }, [location.pathname]);

    return <div className="row gap-4 ps-3 pe-3 pb-2">
        <div className='col-xl-7 ps-0 pe-0'>
            <TopChart height={300} year={year} setYear={setYear} />
        </div>
        <div className='col ps-0 pe-0'>
            <TicketsByStatuses height={300} year={year} />
        </div>
        <div className='col-xl-7 ps-0 pe-0'>
            <TicketsByMonth height={450} year={year} />
        </div>
        <div className='col ps-0 pe-0'>
            <TicketsToStaff height={450} year={year} />
        </div>
    </div>
}
export default Dashboard;